module.exports = __webpack_public_path__ + "static/media/fiskkit_tag_distribution.4a902415.jpg";